(function(){
  if (window.amzCartDrawer) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ar = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var FREE = window.amzFreeShipping || 50000;
  var T = ar ? {
    title: 'سلة التسوق', close: 'إغلاق', empty: 'السلة فاضية', shop: 'كمّل تسوق',
    subtotal: 'الإجمالي', checkout: 'إتمام الشراء', view: 'عرض السلة', remove: 'حذف',
    dec: 'قلّل الكمية', inc: 'زوّد الكمية', added: 'اتضاف للسلة',
    left: function(m){ return 'فاضلك ' + m + ' وتاخد شحن مجاني'; }, free: 'مبروك! طلبك عليه شحن مجاني',
    note: 'الشحن بيتحسب في صفحة الدفع'
  } : {
    title: 'Shopping cart', close: 'Close', empty: 'Your cart is empty', shop: 'Continue shopping',
    subtotal: 'Subtotal', checkout: 'Checkout', view: 'View cart', remove: 'Remove',
    dec: 'Decrease quantity', inc: 'Increase quantity', added: 'Added to cart',
    left: function(m){ return 'Add ' + m + ' more for free shipping'; }, free: 'Your order ships free',
    note: 'Shipping is calculated at checkout'
  };
  function money(c){ return window.amzMoney ? window.amzMoney(c) : (c/100).toFixed(2); }
  function esc(s){ var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var d = document.createElement('dialog');
  d.className = 'amzc';
  d.setAttribute('aria-labelledby', 'AmzcTitle');
  d.innerHTML =
    '<div class="amzc__panel">' +
      '<div class="amzc__head"><h2 id="AmzcTitle">' + T.title + ' <span data-c-count></span></h2>' +
      '<button type="button" class="amzc__x" data-c-close aria-label="' + T.close + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="amzc__added" data-c-added hidden><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>' + T.added + '</div>' +
      '<div class="amzc__ship" data-c-ship></div>' +
      '<div class="amzc__body" data-c-body></div>' +
      '<div class="amzc__foot" data-c-foot>' +
        '<div class="amzc__sub"><span>' + T.subtotal + '</span><strong data-c-total></strong></div>' +
        '<p class="amzc__note">' + T.note + '</p>' +
        '<a class="amz-btn amz-btn--primary amzc__go" href="' + root + 'checkout">' + T.checkout + '</a>' +
        '<a class="amz-btn amz-btn--ghost" href="' + root + 'cart">' + T.view + '</a>' +
      '</div>' +
    '</div>';
  document.body.appendChild(d);

  var body = d.querySelector('[data-c-body]');
  var busy = false;

  function render(cart){
    d.querySelector('[data-c-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    d.querySelector('[data-c-total]').textContent = money(cart.total_price);
    d.querySelector('[data-c-foot]').hidden = !cart.item_count;
    var ship = d.querySelector('[data-c-ship]');
    if (cart.item_count) {
      var pct = Math.min(100, Math.round(cart.total_price * 100 / FREE));
      var msg = cart.total_price >= FREE ? T.free : T.left('<b>' + esc(money(FREE - cart.total_price)) + '</b>');
      ship.innerHTML = '<p>' + msg + '</p><div class="amzc__bar"><span style="width:' + pct + '%"></span></div>';
      ship.classList.toggle('is-done', cart.total_price >= FREE);
      ship.hidden = false;
    } else { ship.hidden = true; }
    document.querySelectorAll('[data-amz-cart-count]').forEach(function(c){ c.textContent = cart.item_count; c.dataset.count = cart.item_count; });
    if (!cart.item_count) {
      body.innerHTML = '<div class="amzc__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 3h3l2.4 11.2a1.5 1.5 0 0 0 1.5 1.2h8.7a1.5 1.5 0 0 0 1.5-1.1L21 7H6"/><circle cx="9" cy="20" r="1.4"/><circle cx="17.5" cy="20" r="1.4"/></svg><p>' + T.empty + '</p><button type="button" class="amz-btn amz-btn--primary" data-c-close>' + T.shop + '</button></div>';
      return;
    }
    body.innerHTML = '<ul class="amzc__list">' + cart.items.map(function(it, i){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + esc(money(it.original_line_price)) + '</s>' : '';
      return '<li class="amzc__item" data-line="' + (i + 1) + '">' +
        '<a class="amzc__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="amzc__info">' +
          '<a class="amzc__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="amzc__var">' + esc(it.variant_title) + '</span>' : '') +
          '<div class="amzc__price"><strong>' + esc(money(it.final_line_price)) + '</strong>' + was + '</div>' +
          '<div class="amzc__row">' +
            '<div class="amzc__qty"><button type="button" data-c-q="-1" aria-label="' + T.dec + '">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-c-q="1" aria-label="' + T.inc + '">+</button></div>' +
            '<button type="button" class="amzc__rm" data-c-rm>' + T.remove + '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('') + '</ul>';
  }

  function load(){ return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){ render(c); return c; }); }

  function change(line, qty){
    if (busy) return; busy = true;
    d.classList.add('is-busy');
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function(r){ return r.json(); }).then(render)
      .finally(function(){ busy = false; d.classList.remove('is-busy'); });
  }

  function open(justAdded){
    d.querySelector('[data-c-added]').hidden = !justAdded;
    if (!d.open) { d.showModal ? d.showModal() : d.setAttribute('open', ''); }
    document.documentElement.classList.add('amzc-lock');
  }
  function close(){ d.close ? d.close() : d.removeAttribute('open'); }
  d.addEventListener('close', function(){ document.documentElement.classList.remove('amzc-lock'); });

  d.addEventListener('click', function(e){
    if (e.target === d || e.target.closest('[data-c-close]')) { close(); return; }
    var li = e.target.closest('[data-line]'); if (!li) return;
    var line = parseInt(li.dataset.line, 10);
    var q = parseInt(li.querySelector('.amzc__qty span').textContent, 10);
    var b = e.target.closest('[data-c-q]');
    if (b) change(line, Math.max(0, q + parseInt(b.dataset.cQ, 10)));
    if (e.target.closest('[data-c-rm]')) change(line, 0);
  });

  document.addEventListener('amz:cart-updated', function(e){
    if (e.detail) render(e.detail);
    open(true);
  });

  document.addEventListener('click', function(e){
    var a = e.target.closest('.amzh a[href$="/cart"], .amzh__tabbar a[href$="/cart"], .amz-toast a[href$="/cart"]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    load().then(function(){ open(false); });
  });

  window.amzCartDrawer = { open: function(){ load().then(function(){ open(false); }); }, close: close };
})();
